// Labels for the status and risk badges on proposal cards and the drawer.
// Known values go through i18n; an unknown value falls back to the raw
// rendering the badges used before (underscores as spaces, risk upper-cased).

type Translate = (key: string) => string;

export const PROPOSAL_STATUS_KEYS: Record<string, string> = {
  proposed: 'Proposed',
  pending_review: 'PendingReview',
  approved: 'Approved',
  denied: 'Denied',
  executing: 'MyProposalsStatusExecuting',
  completed: 'Completed',
  failed: 'Failed',
  expired: 'Expired',
  rolled_back: 'RolledBack',
};

export const PROPOSAL_RISK_KEYS: Record<string, string> = {
  low: 'RiskLow',
  medium: 'RiskMedium',
  high: 'RiskHigh',
  critical: 'RiskCritical',
};

export function proposalStatusLabel(t: Translate, status: string): string {
  const key = PROPOSAL_STATUS_KEYS[status];
  return key ? t(key) : status.replace(/_/g, ' ');
}

/** Upper-cased, as the risk badge has always shown it. */
export function proposalRiskLabel(t: Translate, level: string): string {
  const key = PROPOSAL_RISK_KEYS[level];
  return (key ? t(key) : level).toUpperCase();
}
